import {
	BoundaryType,
	type Boundary,
} from "@ptx-autonomous/libs/flightpath-service-api-models";
import { Speed } from "@ptx-autonomous/libs/units";

export function isZoneBoundaryType(type: BoundaryType) {
	return (
		type === BoundaryType.SpeedZone || type === BoundaryType.NoCoverageZone
	);
}

export function toDisplayZoneBoundary<T extends Boundary>(zone: T): T {
	if (!zone.SpeedLimit || !isZoneBoundaryType(zone.type)) {
		return zone;
	}

	return {
		...zone,
		SpeedLimit: Number(
			new Speed(zone.SpeedLimit, "m/s").convert("mph").toFixed(2),
		),
	};
}

export function filterSelectableMissionZones<T extends Boundary>(zones: T[]) {
	return zones.filter(zone => zone.type !== BoundaryType.NoGoZone);
}

export function getZoneTypeLabel(zone: Pick<Boundary, "type">) {
	return zone.type === BoundaryType.SpeedZone ? "Slow Zone" : "No-Till Zone";
}

export function getZoneDisplayName(zone: Pick<Boundary, "name" | "type">) {
	return zone.name?.trim() || getZoneTypeLabel(zone);
}
